export const articles = {
  title: '記事',
  searchPlaceholder: '記事を検索...',
  allCategories: 'すべてのカテゴリー',
  readMore: '続きを読む'
};

export default articles;
